import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = {
  children: ReactNode
}

type State = {
  error: Error | null
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[Memoria] render error', error, info.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  handleRetry = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="mem-page mem-page--center" style={{ padding: 24 }}>
        <main className="mem-main">
          <h1 style={{ margin: '0 0 12px', fontFamily: 'var(--mem-font-display)' }}>Something went wrong</h1>
          <p style={{ margin: '0 0 20px', color: 'var(--mem-text-muted)', maxWidth: 420 }}>
            Memoria hit an unexpected error. Try again or reload the page.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button type="button" className="mem-btn mem-btn--primary" onClick={this.handleRetry}>
              Try again
            </button>
            <button type="button" className="mem-btn mem-btn--ghost" onClick={this.handleReload}>
              Reload
            </button>
          </div>
        </main>
      </div>
    )
  }
}
